<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Users",
};
</script>

<style scoped></style>
